<template>
  <div>

  </div>
</template>

<script>
export default {
  mounted() {
    alert('en')
  }
}
</script>

<style>
* {
  font-family: en-light !important;
}
</style>